import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { FilterQuery } from "shared";

export type SearchReliablesDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.searchReliables,
  200
>;

export const searchReliables = async ({
  id,
  filterParams,
  dimensionWeight,
}: {
  id: string | undefined;
  filterParams?: FilterQuery;
  dimensionWeight?: number;
}): Promise<SearchReliablesDto | undefined> => {
  if (!id) {
    return undefined;
  }

  const response = await api.quoteRequestLines.searchReliables.query({
    params: { id },
    query: {
      ...filterParams,
      dimensionWeight,
    },
    timeout: 30000,
  });

  if (response.status === 200) {
    return response.body;
  }

  return [];
};
